import ContactForm from "../pages/contact/contact-form";
import React from "react";

const DzikaTerapiaMapEmbed = () => (
    <iframe width="100%" height="100%" load="lazy" allowFullScreen
            src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ23wVnWTJFkcRxDleMgY5Gkk&key=AIzaSyCNHvBdoJdhr6biOTzjtMDOxXpQZ27kxYw"></iframe>
);

const ContactSection = () => (
  <div className="content pt-6" id={"contact"}>
    <h2 className="title">Pozostańmy w kontakcie</h2>
    <div className="columns mt-6">
      <div className="column is-half">
          <div className={"card"} style={{height: 100 + "%"}}>
              <DzikaTerapiaMapEmbed />
          </div>
      </div>
        <div className={"column"}>
            <div className="card p-2" style={{height: 100 + '%'}}>
                <ContactForm/>
            </div>
        </div>
    </div>
  </div>
);

export default ContactSection;
